import { useMemo } from 'react';

// material-ui
import { Typography } from '@mui/material';

import { useAuthContext } from 'src/contexts/AuthProvider';
import { getMenuItems } from 'src/menu-items/pages';

import NavGroup from './NavGroup';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { user } = useAuthContext();

    const menuItems = useMemo(() => getMenuItems(user?.role), [user]);

    if (menuItems) {
        const navItems = menuItems?.items?.map((item) => {
            if (item) {
                switch (item.type) {
                    case 'group':
                        return <NavGroup key={item.id} item={item} />;
                    default:
                        return (
                            <Typography key={item.id} variant="h6" color="error" align="center">
                                Menu Items Error
                            </Typography>
                        );
                }
            }
        });

        return <>{navItems}</>;
    } else {
        return null;
    }
};

export default MenuList;
